var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTypeRing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_903_26709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.0264 27.5024C-1.9769 52.6668 -11.7226 106.965 15.2595 148.779C42.2391 190.593 95.7251 204.088 134.723 178.928L157.325 164.5C150.372 168.893 142.956 172.043 135.331 174.059C126.319 176.441 117.011 177.147 107.762 176.387C81.0251 174.181 54.8808 159.316 38.5105 133.939C22.135 108.563 19.3657 78.6173 28.3745 53.3495C31.4903 44.6071 35.9713 36.4155 41.8565 29.1857C46.9892 22.8791 53.1302 17.2758 60.2746 12.6628L37.0264 27.5024ZM157.325 164.5C157.542 164.363 157.757 164.226 157.972 164.086L157.325 164.5Z",
    fill: "url(#paint0_linear_903_26709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0312 26.2464L69.4294 26.8618C96.166 29.0648 122.308 43.9328 138.681 69.3093C155.056 94.6857 157.825 124.626 148.817 149.899L149.212 150.512C181.216 129.862 189.216 85.302 167.075 50.9867C152.483 28.3719 128.444 15.8517 104.588 15.8517C92.2408 15.8517 79.9456 19.2029 69.0312 26.2464Z",
    fill: "url(#paint1_linear_903_26709)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.2826 12.662C53.1382 17.2749 46.9971 22.8782 41.8645 29.1848C35.9793 36.4146 31.4983 44.6062 28.3825 53.3486C19.3737 78.6164 22.143 108.562 38.5185 133.938C54.8888 159.315 81.0331 174.18 107.77 176.386C117.019 177.146 126.327 176.44 135.339 174.058C143.202 171.98 150.84 168.693 157.98 164.085C196.983 138.923 206.723 84.6256 179.744 42.8143C161.964 15.2581 132.67 -0.000411987 103.601 -0.000411987C88.5576 -0.00300598 73.5811 4.08247 60.2826 12.662ZM69.0406 26.2423C101.047 5.59 144.945 16.6673 167.084 50.9826C189.226 85.2979 181.225 129.858 149.222 150.508L148.826 149.895C148.702 150.236 148.604 150.59 148.477 150.932C132.588 160.892 113.877 163.165 96.3614 158.71C78.6724 154.208 62.2193 142.88 51.1808 125.77C40.1371 108.652 36.5973 88.9955 39.7855 71.0247C42.9453 53.2296 52.7245 37.1179 68.3449 26.7439C68.7121 26.7698 69.0742 26.8266 69.4388 26.8576L69.0406 26.2423Z",
    fill: "url(#paint2_linear_903_26709)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_903_26709",
    x1: 78.9876,
    y1: 202.034,
    x2: 13.5291,
    y2: 30.5029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.164185,
    stopColor: "#12A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.741774,
    stopColor: "#ADE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79893,
    stopColor: "#ADE8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_903_26709",
    x1: 79.0275,
    y1: 119.507,
    x2: 123.941,
    y2: 17.8383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.106599,
    stopColor: "#12A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.481605,
    stopColor: "#5FBFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596347,
    stopColor: "#5FBFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5FBFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_903_26709",
    x1: 44.797,
    y1: 24.035,
    x2: 152.9,
    y2: 168.146,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#12A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221341,
    stopColor: "#12A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005CFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_903_26709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 148,
    height: 148,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeRing);
export default __webpack_public_path__ + "static/media/Type=Ring.12d5f641d7b0bdd26d5a248836e617ea.svg";
export { ForwardRef as ReactComponent };